import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  ModalProps,
  Circle,
  VStack,
  Text,
} from '@chakra-ui/react';
import { ReactNode } from 'react';

import { Button } from 'components/Button';
import { CrossIcon, FolderWithCheckmarkIcon } from 'components/Icons';

export type Props = {
  /** Issue de l'action, pilote l'icône et les couleurs (succès vert / échec rouge). */
  success: boolean;
  /** Message renvoyé par l'API à afficher à l'utilisateur. */
  message: string;
  /** Contenu additionnel affiché sous le message en cas de succès (ex. encart "simply"). */
  extraContent?: ReactNode;
} & Omit<ModalProps, 'children'>;

export const ResultModal = ({ success, message, extraContent, ...props }: Props) => {
  return (
    <Modal {...props} scrollBehavior="inside" size="md" isCentered>
      <ModalOverlay bg="blackAlpha.600" />
      <ModalContent borderRadius="2xl" overflow="hidden" mx={4}>
        <ModalCloseButton />
        <ModalBody px={8} pt={16} pb={12}>
          <VStack spacing={6} textAlign="center">
            <Circle
              size="72px"
              bg={success ? 'teal.50' : 'red.50'}
              color={success ? 'teal.500' : 'red.500'}
            >
              {success ? <FolderWithCheckmarkIcon boxSize="34px" /> : <CrossIcon boxSize="28px" />}
            </Circle>
            {message && (
              <Text fontSize="lg" fontWeight="bold" color={success ? 'teal.900' : 'red.500'}>
                {message}
              </Text>
            )}
            {success && extraContent}
            <Button colorScheme={success ? 'teal' : 'gray'} onClick={props.onClose} px={12} mt={2}>
              Fermer
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
